import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const exchange = async () => {
      try {
        const { data } = await api.post("/auth/google", { session_id: sessionId });
        setUser(data);
        toast.success(`Welcome, ${data.name.split(" ")[0]}.`);
        navigate(data.role === "admin" ? "/admin" : "/", { replace: true, state: { user: data } });
      } catch {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    };
    exchange();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#08090C] flex items-center justify-center" data-testid="auth-callback-loading">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-gold/30 border-t-gold rounded-full animate-spin mx-auto mb-5" />
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Signing you in…</p>
      </div>
    </div>
  );
}
